<template lang="pug">
BriqDialog(v-show="show" @close="$emit('close')" @after-close="afterClose")
  h2.mb-S Cash refund
  BriqPriceInput.mb-S(
    label="Amount"
    min="0"
    type="number"
    :currencySymbol="currencySymbol"
    v-model.number="refund"
    required
    :error="refundError"
    data-test-id="cash-refund-input"
    )
  BriqTextarea.mb-S(label="Description" v-model="refundDescription" data-test-id="refund-description")
  .flex.justify-center
    BriqButton.mr-XXS(variant="text" @click="$emit('close')" :disabled="disabled") Cancel
    BriqButton.ml-XXS(@click="addRefund" :disabled="disabled" data-test-id="refund-button") Refund
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import ExternalPaymentApiModel from '@v/bookings/details/ExternalPaymentApiModel.js'
import BriqPriceInput from '@v/components/BriqPriceInput.vue'
import { currencySymbol } from '@/helpers/intlFormatter.js'

export default {
  name: 'CashRefundDialog',
  components: { BriqPriceInput },
  props: {
    show: Boolean,
    disabled: Boolean,
    maxRefundable: { type: Number, required: true },
  },
  data() {
    return {
      refund: this.show ? this.maxRefundable : 0,
      refundDescription: null,
    }
  },
  validations() {
    return {
      refund: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(this.maxRefundable),
      },
    }
  },
  computed: {
    refundError() {
      return this.$v.refund.$error && this.show
        ? `Refund must be between 0 and ${this.maxRefundable}`
        : null
    },
    currencySymbol() {
      return currencySymbol(this.$locale, this.$currency)
    },
  },
  methods: {
    addRefund() {
      this.$v.$touch()
      if (this.$v.$error) return
      const refundModel = new ExternalPaymentApiModel({
        Amount: -this.refund,
        Description: this.refundDescription,
        PaymentMethod: 'Cash',
      })
      this.$emit('save', refundModel)
    },
    afterClose() {
      this.refund = 0
      this.refundDescription = null
      this.$v.$reset()
    },
  },
  watch: {
    show(v) {
      if (v) this.refund = this.maxRefundable || 0
    },
  },
  mounted() {
    this.$bus.$on('showRefundDialog', payment => {
      this.refund = payment?.Amount || 0
    })
  },
}
</script>
